export default function authHeader() {
  const obj = JSON.parse(sessionStorage.getItem("authUser"))
  const cityhall = JSON.parse(localStorage.getItem("cityhall"))
  if (obj && obj.token ) {
    return { Authorization: "Bearer " + obj.token, token: obj.token, cityhall: cityhall }
  } else {
    return {}
  }
}
